import { Link } from "react-router-dom";
import { getHotArticles } from "@/mocks/articles";

export default function ArticlesSection() {
  const articles = getHotArticles(6);

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-12">
          <div>
            <div className="inline-flex items-center gap-2 text-accent-500 text-sm font-medium mb-3">
              <i className="ri-fire-line"></i>
              <span>热门内容</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              精选原创内容推荐
            </h2>
          </div>
          <Link
            to="/category/image-text"
            className="hidden sm:flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Featured + list layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Featured card */}
          {articles[0] && (
            <Link
              to={`/article/${articles[0].id}`}
              className="group relative overflow-hidden rounded-2xl bg-background-50 cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
            >
              <div className="w-full h-72 md:h-80">
                <img
                  src={articles[0].coverImage}
                  alt={articles[0].title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/30 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <span className="inline-block px-2.5 py-1 bg-primary-500 text-background-50 text-xs rounded-full mb-3">
                  {articles[0].category}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 line-clamp-2 mb-2">
                  {articles[0].title}
                </h3>
                <div className="flex items-center gap-4 text-background-50/60 text-xs">
                  <span><i className="ri-user-line mr-1"></i>{articles[0].author}</span>
                  <span><i className="ri-time-line mr-1"></i>{articles[0].readTime}</span>
                  <span><i className="ri-eye-line mr-1"></i>{articles[0].views.toLocaleString()}</span>
                </div>
              </div>
            </Link>
          )}

          {/* Article list */}
          <div className="flex flex-col gap-4">
            {articles.slice(1, 5).map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group flex gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
                onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
              >
                <div className="w-24 h-20 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="inline-block px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full mb-2">
                    {article.category}
                  </span>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-3 text-foreground-500 text-xs mt-1.5">
                    <span>{article.author}</span>
                    <span><i className="ri-eye-line mr-0.5"></i>{article.views.toLocaleString()}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/image-text"
            className="inline-flex items-center gap-1 text-primary-500 text-sm font-medium"
            onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
          >
            查看全部内容 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}